export const serverDeviceControl = process.env.REACT_APP_SERVER_DEVICE_CONTROL
export const serverDeviceLog = process.env.REACT_APP_SERVER_DEVICE_LOG
export const serverDataControl = process.env.REACT_APP_SERVER_DATA_CONTROL
